import React from 'react';

const PaperAirplaneIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="13" viewBox="0 0 17 13" fill="none">
      <path d="M0.5 13V0L16.5 6.5L0.5 13ZM2.18421 10.5625L12.1632 6.5L2.18421 2.4375V5.28125L7.23684 6.5L2.18421 7.71875V10.5625ZM2.18421 10.5625V2.4375V7.71875V10.5625Z" fill="white"/>
    </svg>
  );
};

export default PaperAirplaneIcon;
